import { render, staticRenderFns } from "./RecordSearch.vue?vue&type=template&id=f40dba3a&"
import script from "./RecordSearch.vue?vue&type=script&lang=js&"
export * from "./RecordSearch.vue?vue&type=script&lang=js&"
import style0 from "./RecordSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports